const resolveClientRoot = () => {
    if (process.env.REACT_APP_CLIENT_ROOT) {
        return process.env.REACT_APP_CLIENT_ROOT;
    }

    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/`;
    }

    return 'https://localhost:44363/';
};

const DEFAULT_CLIENT_ROOT = resolveClientRoot();

export const IDENTITY_CONFIG_LOCAL = {
    stsAuthority: 'https://identity.cembenchmarking.com/core/',
    clientId: 'Cem.Surveys2019',
    clientSecret: "c2VjcmV0Y29kZQ==",
    clientRoot: DEFAULT_CLIENT_ROOT,
    clientScope: 'openid profile email roles Surveys2019Api TemplateUploadToolApi',
};

export const IDENTITY_CONFIG_INTRA = {
    stsAuthority: 'https://identity.cembenchmarking.com/core/',
    clientId: 'Cem.Surveys2019',
    clientSecret: "c2VjcmV0Y29kZQ==",
    clientRoot: 'https://surveys2019.cembenchmarking.com/',
    clientScope: 'openid profile email roles Surveys2019Api TemplateUploadToolApi',
};

export const IDENTITY_CONFIG_LIVE = {
    stsAuthority: 'https://identity.cembenchmarking.com/core/',
    clientId: 'LiveSurveys',
    clientSecret: "U3VwM3JTZUNyM3RQYTU1VzBSZFBAYlM=",
    clientRoot: 'https://surveys.cembenchmarking.com/',
    clientScope: 'openid profile email roles Surveys2019Api TemplateUploadToolApi',
};
